export const REGEX = {
  referralName: /^[^\s][a-zA-Z0-9\s\u4E00-\u9FFF!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
  specialChars: /[^\u4e00-\u9fa5]/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  name: /^[A-Za-z][A-Za-z\s-]*$/,
}
